import React from "react"
import { Box, BoxProps, Button, Flex, Input } from "@chakra-ui/react"
import Icon from "@app/components/Icon"

type Props = {
  changeQuantity: (qnt: number) => void
  product: any
  quantity: number
} & BoxProps

const ProductQuantitySelector: React.FC<Props> = ({ product, quantity, changeQuantity, ...props }) => {
  const showQuantity = true

  const handleMinusClick = () => {
    if (quantity > 1) {
      changeQuantity(quantity - 1)
    }
  }

  const handlePlusClick = () => {
    changeQuantity(quantity + 1)
  }

  return product?.productType !== "Gift Card" && showQuantity ? (
    <Flex
      backgroundColor="primary.white"
      justifyContent="space-between"
      alignItems="center"
      mx="auto"
      border="1px solid"
      borderColor="brand.darkBlue"
      borderRadius="40px"
      maxHeight="48px"
      {...props}
    >
      <Button
        display="flex"
        variant="unstyled"
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          handleMinusClick()
        }}
        opacity={quantity <= 1 ? "0.5" : "1"}
        aria-label="Decrease Quantity"
        title="Decrease Quantity"
        width="33%"
        tabIndex={-1}
      >
        <Icon name="minus" width="8px" height="auto" pointerEvents="none" />
      </Button>
      <Box pos="relative" background="white">
        <Input
          type="number"
          textAlign="center"
          value={quantity}
          variant="unstyled"
          onChange={e => changeQuantity(parseInt(e.target.value))}
          onClick={e => {
            e.preventDefault()
          }}
          w="30px"
        />
      </Box>
      <Button
        display="flex"
        variant="unstyled"
        onClick={e => {
          e.preventDefault()
          e.stopPropagation()
          handlePlusClick()
        }}
        aria-label="Increase Quantity"
        title="Increase Quantity"
        width="33%"
        tabIndex={-1}
      >
        <Icon name="plus" width="8px" height="auto" pointerEvents="none" />
      </Button>
    </Flex>
  ) : null
}

export default React.memo(ProductQuantitySelector)
